import { render } from "./edit-question.vue?vue&type=template&id=7cf0dc56&ts=true"
import script from "./edit-question.vue?vue&type=script&lang=ts"
export * from "./edit-question.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__